import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { NgbModal } from '../../../../node_modules/@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from '../../core/components';
import { IPagedResults } from '../../core/interfaces';
import { LoanService } from '../../services';
import { modalLarge, modalSmall } from '../../shared/modules/dialogOptions';
import { CustomersCreateEditComponent } from './customers-create-edit.component';

@Component({
    selector: 'app-customers-list',
    templateUrl: './customers-list.component.html',
    styleUrls: ['../layout/layout.component.scss']
})
export class CustomersListComponent extends BaseComponent implements OnInit {
    public showSpinner: boolean = false;
    public itemPerPage: number = 100;
    public currentPage: number = 1;
    public totalItems: number = 10;
    public isAdminOrUserEditor = false;
    public isSuperAdmin = false;
    public accountId: number = 0;

    public selectedCustomer: any;
    public dataTable: any;
    constructor(
        private loanService: LoanService,
        private route: ActivatedRoute,
        private router: Router,
        private location: Location,
        private toastr: ToastsManager,
        private chRef: ChangeDetectorRef,
        private modalService: NgbModal) {
        super(router);
    }

    packageData: Subject<any> = new Subject<any[]>();
    public ngOnInit() {
    }

    public loadDataByAccountId(accountId: number, siteId: number) {
        this.accountId = accountId;
        this.showSpinner = true;
        this.loanService.getCustomerByAccountList(accountId, siteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response: IPagedResults<any>) => {
                this.packageData.next(response.Data);
                this.totalItems = response.Data.length;
                this.packageData.next(response.Data);
                this.chRef.detectChanges();
            });
    }

    public editCustomer(id: number) {
        // this.router.navigate([`/customers/${id}/edit`]);

        const modalRef = this.modalService.open(CustomersCreateEditComponent, modalLarge);
        modalRef.componentInstance.modalIdData = id;
        //modalRef.componentInstance.modalSiteId = this.siteId;
        modalRef.result.then((result) => {
            let siteId = +localStorage.getItem('LoanscurrentSiteId')
            let currentUser = super.currentLoggedUser();
            this.loadDataByAccountId(currentUser.accountId, siteId);
            this.ngOnInit();
            //alert(result);
            //this.loadDataById(result);
        }, (reason) => {
            let siteId = +localStorage.getItem('LoanscurrentSiteId')
            let currentUser = super.currentLoggedUser();
            this.loadDataByAccountId(currentUser.accountId, siteId);
            //this.loadDataById(currentUser.accountId,this.siteId);
            this.ngOnInit();
            // alert(reason +"aaa");
        });
    }

    public confirmDeleteCustomer(content: string, item: any) {
        this.selectedCustomer = item;
        this.modalService.open(content, modalSmall);
    }

    public deleteCustomer() {
        this.showSpinner = true;
        this.loanService.deleteCustomer(this.selectedCustomer)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response) => {
                if (!response.Success) {
                    this.toastr.error(response.Message, 'Error');
                }
                let siteId = +localStorage.getItem('LoanscurrentSiteId')

                this.loadDataByAccountId(this.accountId, siteId);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/customers/customers-list.component.ts